<template>
  <div class="row">
    <div class="col-lg-3 col-md-6 text-center">
      <div class="mt-5">
        <i class="fas fa-4x fa-heart icon-color mb-4"></i>
        <h3 class="h4 mb-2">Dedicated</h3>
        <p class="text-muted mb-0">
          Just like I always say, work with your heart and mind.
        </p>
      </div>
    </div>
    <div class="col-lg-3 col-md-6 text-center">
      <div class="mt-5">
        <i class="fas fa-4x fa-laptop-code icon-color mb-4"></i>
        <h3 class="h4 mb-2">Loves to Code</h3>
        <p class="text-muted mb-0">
          Learning and creating new things is an integral part of my life.
        </p>
      </div>
    </div>
    <div class="col-lg-3 col-md-6 text-center">
      <div class="mt-5">
        <i class="fas fa-4x fas fa-paw icon-color mb-4"></i>
        <h3 class="h4 mb-2">Furry Friends</h3>
        <p class="text-muted mb-0">
          To quote all Dog lovers "A dog is a man's best friend".
        </p>
      </div>
    </div>
    <div class="col-lg-3 col-md-6 text-center">
      <div class="mt-5">
        <i class="fas fa-4x fa-jedi icon-color mb-4"></i>
        <h3 class="h4 mb-2">Star Wars Fan</h3>
        <p class="text-muted mb-0">
          Flashes of lightsaber and seeing the use of the force on screen really
          tingles my inner nerdiness
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about-body",
};
</script>

<style scoped>
.icon-color {
  color: #66ccff;
}
</style>